import { useCallback, useState } from 'react';

export const useScreenReaderAnnouncement = () => {
  const [announcement, setAnnouncement] = useState('');

  const announceError = useCallback((errorMessage: string) => {
    setAnnouncement(errorMessage);
    setTimeout(() => {
      setAnnouncement('');
    }, 100);
  }, []);

  const clearAnnouncement = useCallback(() => {
    setAnnouncement('');
  }, []);

  return {
    announcement,
    announceError,
    clearAnnouncement,
  };
};
